"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasChildBundleCriteria = exports.areSameChildBundleCriteria = exports.timeSlotToTimeRanges = exports.timeRangeKey = exports.isValidTimeRange = exports.getDepartementCode = exports.vehicleToTransportMode = exports.transportModeToVehicles = void 0;
var moment_1 = __importDefault(require("@ambler/moment"));
var utils_1 = require("./utils");
var transportModeToVehicles = function (transportMode) {
    switch (transportMode) {
        case 'AMB':
            return ['AMBULANCE', 'BARIATRIC', 'MEDICAL', 'PARAMEDICAL'];
        case 'TAP':
            return ['VSL', 'TAXI'];
        case 'TPMR':
            return ['TPMR'];
    }
    (0, utils_1.assertUnreachable)(transportMode);
};
exports.transportModeToVehicles = transportModeToVehicles;
var vehicleToTransportMode = function (vehicle) {
    switch (vehicle) {
        case 'AMBULANCE':
        case 'BARIATRIC':
        case 'MEDICAL':
        case 'PARAMEDICAL':
            return 'AMB';
        case 'VSL':
        case 'TAXI':
            return 'TAP';
        case 'TPMR':
            return 'TPMR';
        case 'TPS':
            throw Error('TPS in vehicleToTransportMode');
    }
    (0, utils_1.assertUnreachable)(vehicle);
};
exports.vehicleToTransportMode = vehicleToTransportMode;
var getDepartementCode = function (inseeCode) {
    return inseeCode.startsWith('97') || inseeCode.startsWith('98') ? inseeCode.slice(0, 3) : inseeCode.slice(0, 2);
};
exports.getDepartementCode = getDepartementCode;
var isValidTimeRange = function (range) {
    return [range.startDay, range.endDay].every(function (day) { return Number.isInteger(day) && day >= 1 && day <= 7; }) &&
        [range.startHour, range.endHour].every(function (hour) { return Number.isInteger(hour) && hour >= 0 && hour <= 23; });
};
exports.isValidTimeRange = isValidTimeRange;
var timeRangeKey = function (range) {
    return "".concat(range.startDay, ":").concat(range.startHour, "-").concat(range.endDay, ":").concat(range.endHour, "-").concat(range.holidays);
};
exports.timeRangeKey = timeRangeKey;
// The time ranges equivalent to a legacy `timeSlot`. Used by the one-shot migration script and
// by the BO to prefill the form when editing a bundle that has not been migrated yet.
var timeSlotToTimeRanges = function (timeSlot) {
    switch (timeSlot) {
        case 'NIGHT':
            return [1, 2, 3, 4, 5, 6, 7].map(function (day) { return ({
                startDay: day,
                startHour: 20,
                endDay: (day % 7) + 1,
                endHour: 8,
                holidays: 'INCLUDED',
            }); });
        case 'SUNDAY_HOLIDAY':
            return [
                { startDay: 7, startHour: 0, endDay: 1, endHour: 0, holidays: 'INCLUDED' },
                { startDay: 1, startHour: 0, endDay: 1, endHour: 0, holidays: 'ONLY' },
            ];
        case 'DEFAULT':
            return [];
    }
    (0, utils_1.assertUnreachable)(timeSlot);
};
exports.timeSlotToTimeRanges = timeSlotToTimeRanges;
// * Set comparison: neither the order nor duplicates are meaningful here.
var areSameSet = function (a, b) {
    var setA = new Set(a);
    var setB = new Set(b);
    return setA.size === setB.size && a.every(function (value) { return setB.has(value); });
};
var isSameRotation = function (a, b) {
    if (a.rotationWeeksInterval !== b.rotationWeeksInterval) {
        return false;
    }
    if (!a.rotationFirstWeekDate || !b.rotationFirstWeekDate) {
        return Boolean(a.rotationFirstWeekDate) === Boolean(b.rotationFirstWeekDate);
    }
    return (0, moment_1.default)(a.rotationFirstWeekDate).isSame(b.rotationFirstWeekDate, 'isoWeek');
};
var areSameChildBundleCriteria = function (a, b) {
    return a.timeSlot === b.timeSlot &&
        areSameSet(a.timeRanges.map(exports.timeRangeKey), b.timeRanges.map(exports.timeRangeKey)) &&
        areSameSet(a.inseeCodes, b.inseeCodes) &&
        areSameSet(a.sectorGroupIds, b.sectorGroupIds) &&
        areSameSet(a.transportReasons, b.transportReasons) &&
        isSameRotation(a, b);
};
exports.areSameChildBundleCriteria = areSameChildBundleCriteria;
/**
 * `DEFAULT` is the absence of a time slot criterion, so such a bundle needs another criterion to
 * stand out from its parent.
 */
var hasChildBundleCriteria = function (_a) {
    var timeSlot = _a.timeSlot, timeRanges = _a.timeRanges, inseeCodes = _a.inseeCodes, sectorGroupIds = _a.sectorGroupIds, transportReasons = _a.transportReasons, rotationFirstWeekDate = _a.rotationFirstWeekDate, rotationWeeksInterval = _a.rotationWeeksInterval;
    return timeSlot !== 'DEFAULT' ||
        timeRanges.length > 0 ||
        inseeCodes.length > 0 ||
        sectorGroupIds.length > 0 ||
        transportReasons.length > 0 ||
        (rotationFirstWeekDate != null && rotationWeeksInterval != null);
};
exports.hasChildBundleCriteria = hasChildBundleCriteria;
//# sourceMappingURL=tdr.js.map